module.exports = __webpack_public_path__ + "components/MapControl/svg/Dworzec autobusowy.svg?91a93d56";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Dworzec autobusowy.svg
// module id = 1965
// module chunks = 0